import React from "react";
import { Stack } from "@mui/material";
import {Header} from './Sections/Header';
import {ProactiveMessagesBoxContainer} from './Sections/ProactiveMessagesBoxContainer';
import {styles} from './Utilities/ProactiveMetricsDetailStyles';
import {MetricsDetailFooter as Footer} from "../MetricsDetail/Sections/MetricsDetailFooter";

export const CampaignMetricsDetailComponent = ({
                                                   source,
                                                   organizationId,
                                                   pageFilter,
                                                   isFilterDropdownOpen,
                                                   setIsFilterDropdownOpen,
                                                   isCampaignNameDropdownOpen,
                                                   setIsCampaignNameDropdownOpen,
                                                   selectedCheckboxes,
                                                   setSelectedCheckboxes,
                                                   selectedCriteria,
                                                   setSelectedCriteria,
                                                   filterRef,
                                                   filterPageRef,
                                                   handleExport,
                                                   pageParams,
                                                   setPageParams,
                                                   selectedDropdownOption,
                                                   onSelectChangeHandler,
                                                   onFilterFormSubmit,
                                                   handleFilterReset,
                                                   dateRange,
                                                   setDateRange,
                                                   extractedCampaignList,
                                                   setLiked,
                                                   setReplied,
                                                   setNoEngagement,
                                                   setFollowed,
                                                   setConverted,
                                                   setFollowUpSent,
                                                   setConvertedAfterFollowUpSent,
                                                   setHasAdditionalOrders,
                                                   setOrderedWithin5Days,
                                                   setOrderedRecommendedCategory,
                                                   setOrderedRecommendedProduct,
                                                   setUsedDiscount,
                                                   setUsedExactDiscountCode,
                                                   setLastTouch,
                                                   sortBy,
                                                   setSortBy,
                                                   orderBy,
                                                   setOrderBy,
                                               }) => {
    const renderMetricsMessageBody = () => {
        return (
            <Stack direction={'row'} sx={{...styles.hero, marginTop: '35px'}} spacing={1}>
                <ProactiveMessagesBoxContainer
                    source={source}
                    organizationId={organizationId}
                    pageFilter={pageFilter}
                    pageParams={pageParams}
                    setPageParams={setPageParams}
                    onFilterFormSubmit={onFilterFormSubmit}
                    sortBy={sortBy}
                    orderBy={orderBy}
                    setSortBy={setSortBy}
                    setOrderBy={setOrderBy}
                />
            </Stack>
        )
    }
    return (
        <>
            <Header
                pageFilter={pageFilter}
                isFilterDropdownOpen={isFilterDropdownOpen}
                setIsFilterDropdownOpen={setIsFilterDropdownOpen}
                isCampaignNameDropdownOpen={isCampaignNameDropdownOpen}
                setIsCampaignNameDropdownOpen={setIsCampaignNameDropdownOpen}
                selectedCriteria={selectedCriteria}
                setSelectedCriteria={setSelectedCriteria}
                filterRef={filterRef}
                filterPageRef={filterPageRef}
                handleExport={handleExport}
                selectedDropdownOption={selectedDropdownOption}
                onSelectChangeHandler={onSelectChangeHandler}
                onFilterFormSubmit={onFilterFormSubmit}
                handleFilterReset={handleFilterReset}
                dateRange={dateRange}
                setDateRange={setDateRange}
                extractedCampaignList={extractedCampaignList}
                setLiked={setLiked}
                setReplied={setReplied}
                setNoEngagement={setNoEngagement}
                setFollowed={setFollowed}
                setConverted={setConverted}
                setFollowUpSent={setFollowUpSent}
                setConvertedAfterFollowUpSent={setConvertedAfterFollowUpSent}
                setHasAdditionalOrders={setHasAdditionalOrders}
                setOrderedWithin5Days={setOrderedWithin5Days}
                setOrderedRecommendedCategory={setOrderedRecommendedCategory}
                setOrderedRecommendedProduct={setOrderedRecommendedProduct}
                setUsedDiscount={setUsedDiscount}
                setUsedExactDiscountCode={setUsedExactDiscountCode}
                setLastTouch={setLastTouch}
            />
            {renderMetricsMessageBody()}
            <Footer />
        </>
    )
}